import { atom } from 'recoil';
import axios from '../utils/axios';
// eslint-disable-next-line import/extensions
import localStorageEffect from './localStorageEffect.js';
import {
  ProductScheduleTemplate,
  ProductScheduleTemplateItem
} from '../@types/model/productScheduleTemplate';

const productScheduleTemplateState = atom<ProductScheduleTemplate[]>({
  key: 'productScheduleTemplate',
  default: [],
  effects: [localStorageEffect('productScheduleTemplate')]
});

const getProductScheduleTemplate = async () => {
  let productScheduleTemplates: ProductScheduleTemplate[] = (
    await axios.get('/api/v2/product-schedule-template')
  ).data.data
    .map((dat: any) => {
      let newItems: ProductScheduleTemplateItem[] = [];
      Object.keys(dat.attributes.items).forEach((key) => {
        newItems.push(dat.attributes.items[key] as ProductScheduleTemplateItem);
      });
      newItems = newItems.sort((a: ProductScheduleTemplateItem, b: ProductScheduleTemplateItem) => {
        if (a.ordinal < b.ordinal) {
          return -1;
        }
        if (a.ordinal > b.ordinal) {
          return 1;
        }
        return 0;
      });
      return {
        guid: dat.guid,
        name: dat.attributes.name,
        type: dat.attributes.type,
        state: dat.attributes.state,
        items: newItems
      } as ProductScheduleTemplate;
    })
    .sort((a: ProductScheduleTemplate, b: ProductScheduleTemplate) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  return productScheduleTemplates;
};

export { productScheduleTemplateState, getProductScheduleTemplate };
